import { useEffect } from 'react';
import MagicHeader from '../../widgets/MagicHeader';
import TermsContent from '../../widgets/TermsContent';
import { useBrandConfig } from '../../../context/BrandConfigContext';
import '../magic.css';

// Own implementation (rather than re-exporting classic's) so the header/logo stay
// consistent with the rest of the magic template instead of the classic default header.
const TermsAndConditions = () => {
  const brand = useBrandConfig();

  const hasContent = brand?.terms_content?.length > 0;
  const externalUrl = brand?.legal?.termsUrl;
  const isExternalUrl = externalUrl && externalUrl.startsWith('http');

  useEffect(() => {
    if (!hasContent && isExternalUrl) {
      window.location.replace(externalUrl);
    }
  }, [hasContent, isExternalUrl, externalUrl]);

  if (!hasContent && isExternalUrl) return null;

  return (
    <div className="magic-theme-light">
      <MagicHeader variant="light" showBack onBack={() => window.history.back()} />
      <main className="page-content strict-width x-space-top">
        <TermsContent
          items={hasContent ? brand.terms_content : undefined}
          heading={'TERMS AND CONDITIONS GOVERNING PARTICIPATION IN THE "COCA-COLA PREMIER LEAGUE DRINK, SCAN, FIND AND WIN PROMOTION" (The "Promotion")'}
        />
      </main>
    </div>
  );
};

export default TermsAndConditions;
